const save = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M.5 15.5V.5h10.91l4.09 4.172V15.5zm4.383-1.192h6.234v-4.37H4.883zM9.948 1.79H6.15v3.775h3.8zm4.383 3.378L11.214 1.99v4.768h-6.33V1.692H1.765V14.21h1.85V8.546h8.767v5.663h1.85z"/></svg>',
};

export { save as default };
